// Dependencias generales
import React from "react";
import { useEffect } from 'react';

const SharedInstallers = (params) => {

  useEffect(() => {        
    console.log("Listado de instaladores compartidos cargado correctamente.")
  }, []);

  const listInstallers = params.listadoInstaladoresCompartidos.map((installer) =>
    
  <React.Fragment key={installer.INSTALLER_ID}>
  
    <ul className="list with-dividers">
      <li className="list-item">
        <figure className="avatar size-l pink"><span className="material-icon">business</span></figure>
        <div className="content">
          <span className="value">{installer.InstallerName}</span>
          <span className="label">{installer.InstallationAddress}</span>
          <span className="label">{installer.InstallationEmail}</span>
          <span className="label">{installer.InstallationPhoneNumber}</span>
        </div>
        <button className="link delete" onClick={() => params.dejarDeCompartirInstalacion(installer.INSTALLATION_ID, "", installer.INSTALLER_ID)}><span className="material-icon">remove_circle</span></button>
      </li>
    </ul>

  </React.Fragment>
);    

  return (          
    
    <div className="content-wrapper"> 
      {listInstallers}
    </div>    
    
  )
}

export default SharedInstallers